// GoodEnglish1aL02.js
// Good English 1A L02 包装组件
// 路由：/ge/1a/l02
import React from 'react';
import GoodEnglish from './good-english/GoodEnglish';
import { dataGoodEnglish1aL02 } from './good-english/good_english_data_1a_l02';

function GoodEnglish1aL02() {
  return <GoodEnglish data={dataGoodEnglish1aL02} />;
}

export default GoodEnglish1aL02;
